import { render } from "./AddGoodieModal.vue?vue&type=template&id=bacdd34a&scoped=true"
import script from "./AddGoodieModal.vue?vue&type=script&lang=js"
export * from "./AddGoodieModal.vue?vue&type=script&lang=js"

import "./AddGoodieModal.vue?vue&type=style&index=0&id=bacdd34a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bacdd34a"]])

export default __exports__